import { Game } from '@Game/Game';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { TButtonState } from '@GFTypes/GameStoreTypes/ButtonState';
import { EActionName } from '@Managers/Events/EActionName';

export const applyButtonBlockers = (game: Game, buttonState: Partial<TButtonState>): void => {
    gambleButtonBlocker(game, buttonState);
    stopButtonBlocker(game, buttonState);
    turboButtonBlocker(game, buttonState);
    freeSpinsButtonBlocker(game, buttonState);
    UIBlocker(game, buttonState);
    freeGamesBlocker(game, buttonState);
    lockAndRollBlocker(game, buttonState);
    bonusBuyBlocker(game, buttonState);
    takeButtonBlocker(game, buttonState);
};

const gambleButtonBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const blockGamble = game.gameStore.get(EGameStoreKeys.AuthenticateGameConfig).gamble.maxTries == 0;

    if (blockGamble) {
        buttonState.isGambleButtonActive = false;
        buttonState.isAutoButtonActive = true;
    }
};

const stopButtonBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const { allowQuickStop } = game.gameStore.get(EGameStoreKeys.EnvironmentConfiguration);

    if (!allowQuickStop) {
        buttonState.isStopButtonActive = false;
    }
};

const turboButtonBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const { allowTurbo } = game.gameStore.get(EGameStoreKeys.EnvironmentConfiguration);

    if (!allowTurbo) {
        buttonState.isTurboButtonActive = false;
    }
};

const freeSpinsButtonBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const freeSpinsState = game.gameStore.get(EGameStoreKeys.Account).bonuses?.freeSpins;

    if (freeSpinsState?.balance) {
        buttonState.isGambleButtonActive = false;
        buttonState.isBetDecreaseButtonActive = false;
        buttonState.isBetIncreaseButtonActive = false;
        buttonState.isMenuButtonActive = false;
        buttonState.isBonusBuyButtonActive = false;
    }
};

const UIBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const isUIBlocked = game.gameStore.get(EGameStoreKeys.IsUIBlocked);

    if (isUIBlocked) {
        buttonState.isAutoButtonActive = false;
        buttonState.isBetDecreaseButtonActive = false;
        buttonState.isBetIncreaseButtonActive = false;
        buttonState.isFullscreenButtonActive = false;
        buttonState.isGambleButtonActive = false;
        buttonState.isMenuButtonActive = false;
        buttonState.isSkipButtonActive = false;
        buttonState.isSpinButtonActive = false;
        buttonState.isStopButtonActive = false;
        buttonState.isTakeButtonActive = false;
        buttonState.isTurboButtonActive = false;
        buttonState.isUnmuteButtonActive = false;
        buttonState.isMuteButtonActive = false;
    }
};

const freeGamesBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const isFreeGamesMode = game.gameStore.get(EGameStoreKeys.IsFreeGamesMode);

    if (isFreeGamesMode) {
        buttonState.isBetDecreaseButtonActive = false;
        buttonState.isBetIncreaseButtonActive = false;
    }
};

const lockAndRollBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const isLockAndRollMode =
        game.gameStore.get(EGameStoreKeys.IsLockAndRollMode) ||
        (game.gameStore.get(EGameStoreKeys.IsGameRestored) && game.gameStore.get(EGameStoreKeys.LockAndRoll).totalSpins > 0);

    if (isLockAndRollMode) {
        buttonState.isBetDecreaseButtonActive = false;
        buttonState.isBetIncreaseButtonActive = false;
    }
};

const bonusBuyBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const isBonusBuyOpened = game.gameStore.get(EGameStoreKeys.BonusBuy).isDialogOpen;

    if (isBonusBuyOpened) {
        buttonState.isAutoButtonActive = false;
        buttonState.isBetDecreaseButtonActive = false;
        buttonState.isBetIncreaseButtonActive = false;
        buttonState.isFullscreenButtonActive = false;
        buttonState.isGambleButtonActive = false;
        buttonState.isMenuButtonActive = false;
        buttonState.isSkipButtonActive = false;
        buttonState.isSpinButtonActive = false;
        buttonState.isStopButtonActive = false;
        buttonState.isTakeButtonActive = false;
        buttonState.isTurboButtonActive = false;
    }
};

const takeButtonBlocker = (game: Game, buttonState: Partial<TButtonState>): void => {
    const isTakeInitiated = game.gameStore.get(EGameStoreKeys.IsTakeInitiated);
    const canPerformTake = game.gameStore.get(EGameStoreKeys.NextActions).includes(EActionName.TAKE);

    if (isTakeInitiated || !canPerformTake) {
        buttonState.isTakeButtonActive = false;
    }
};
